import React from 'react';
import { Heart, Shield, Star, Award } from 'lucide-react';
import { motion } from 'framer-motion';
import { useCmsContent } from '../../hooks/useCmsContent';

const TrustBadges = () => {
  const { getContentValue, loading, getCounterValue } = useCmsContent({ section: 'counters', refreshInterval: 60000 });
  
  const badges = [
    {
      icon: Award, 
      title: getCounterValue('anno_fondazione', 2017).toString(),
      subtitle: "Esperienza nel territorio"
    },
    {
      icon: Heart,
      title: `+${getCounterValue('immobili_venduti', 300)}`,
      subtitle: "Famiglie soddisfatte"
    },
    {
      icon: Shield,
      title: "100%",
      subtitle: "Assistenza garantita"
    },
    {
      icon: Star,
      title: "5/5",
      subtitle: "Recensioni clienti"
    }
  ];

  if (loading) {
    return (
      <section className="py-24 bg-white relative z-10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="animate-pulse flex flex-col items-center">
                <div className="h-12 w-12 bg-gray-200 rounded-full mb-4"></div>
                <div className="h-6 w-20 bg-gray-200 rounded mb-2"></div>
                <div className="h-4 w-32 bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-24 bg-white relative z-10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {badges.map((badge, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex flex-col items-center text-center"
            >
              <badge.icon className="h-12 w-12 text-secondary mb-4" />
              <h3 className="text-lg font-semibold text-primary">{badge.title}</h3>
              <p className="text-gray-600 text-sm">{badge.subtitle}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;